<template>
  <div class="user-profile">
    <div class="outline">
      <v-layout wrap>
        <v-flex md5>
          <v-avatar slot="offset" class="mx-auto d-block" color="indigo" size="130">
            <v-icon dark x-large>
              mdi-account-circle
            </v-icon>
          </v-avatar>
        </v-flex>
        <v-flex md7>
          <p class="title">{{ user.Profile.firstName + ' ' + user.Profile.lastName }}</p>
          <div>
            <span class="detail-title text-gray font-weight-thin">Organisation</span>
            <p>{{ user.Org.name }}</p>
          </div>
          
          <div>
            <span class="detail-title text-gray font-weight-thin">Role</span>
            <p>{{ parseRole }}</p>
          </div>

          <div>
            <span class="category text-gray font-weight-thin ">Email</span>
            <p>{{ user.email }}</p>
          </div>
          <p class="category text-gray font-weight-thin mb-3">Created on {{ user.Profile.created_on }}</p>
          <v-btn
            v-if="!resetMessage.length > 0"
            color="submit-btn"
            @click="togglePasswordForm(false)">
              Change Password
          </v-btn>
          <div v-if="resetSuccess">
            <span 
            :class="{ 'green--text': resetSuccess, 'red--text': !resetSuccess }">{{ resetMessage }}</span>
          </div>
          <v-dialog v-model="displayForm" persistent width="400">
            <UpdatePassword 
              v-if="displayForm" 
              :user="authenticateduser"
              @hideForm="togglePasswordForm"/>
          </v-dialog>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>

import UpdatePassword from "../updatePassword/updatePassword";
// import { Logger } from "aws-amplify";
// const logger = new Logger("Drawer");

export default {
  name: 'UserAvatar',
  components: {
    UpdatePassword
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    authenticateduser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      displayForm: false,
      resetMessage: '',
      resetSuccess: Boolean
    }
  },
  computed: {
    /**
    * removes '_' and converts to title case. Returns as String.
    */
    parseRole: function() {
      let role = this.user.Role.name;
      role = role.toLowerCase().replace('_', ' ');

      return role.replace(
        /\w\S*/g,
        function(role) {
          return role.charAt(0).toUpperCase() + role.substr(1).toLowerCase();
        }
      );
    }
  },
  methods: {
    togglePasswordForm(value) {
      this.displayForm = !this.displayForm;
      if (value) {
        this.handleResetFeedback(value)
      }
    },
    handleResetFeedback (value) {
      this.resetSuccess = value;

      if (this.resetSuccess) {
        this.resetMessage = 'Password reset';
      } else {
        this.resetMessage = 'Error resetting password'
      }
    }
  }
}
</script>

<style lang="scss">
  .user-profile {
    margin-top: 58px;
    .title {
      font-size: 24px !important;
      text-transform: uppercase;
    }
    .detail-title {
      text-transform: capitalize;
      margin-bottom: 0;
    }
    .submit-btn {
      margin-bottom: 10px;
      background-color: #24AB80 !important;
      color: white !important;
    }
  }
</style>